import Axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { ClientApiConfig } from './interfaces';

export class ClientApi {
    public httpClient: AxiosInstance;
    protected debug: boolean;
    protected namespace: string;

    constructor(config?: ClientApiConfig) {
        this.namespace = config?.namespace ?? 'CLIENT_API';
        this.debug = config?.debug ?? false;
        this.httpClient = this.setupHttpClient(config);
    }

    private setupHttpClient(config?: ClientApiConfig) {
        let baseUrl: string;
        if (!config?.baseURL) {
            const envBaseUrl = process.env[`${this.namespace}_URL`] ?? process.env[`NX_${this.namespace}_URL`];
            if (!envBaseUrl) {
                this.debug &&
                    console.warn(
                        `[${this.namespace}] Please make sure you have a valid ${this.namespace}_URL or NX_${this.namespace}_URL value set in your environment`,
                    );
                throw new Error(`[${this.namespace}] No valid baseURL supplied`);
            }
            baseUrl = envBaseUrl;
        } else {
            baseUrl = config?.baseURL;
        }
        const defaultAxiosConfig: AxiosRequestConfig = {
            baseURL: baseUrl,
            ...config,
        };
        return Axios.create(defaultAxiosConfig);
    }
}
